import gsap from 'gsap';

export default (scroller) => {

    const accordion = document.querySelector(".accordion-list");
    if (accordion) {
        let accordionItem = accordion.querySelectorAll('.accordion-list-item');

        accordionItem.forEach((item) => {
            let title = item.querySelector(".accordion-title");
            let svgPlus = item.querySelector(".plus");
            let svgMinus = item.querySelector(".minus");
            title.addEventListener('click', () => {
                let thisItem = item;
                accordionItem.forEach((item) => {
                    if(!thisItem.classList.contains("opened") && (thisItem == item)){
                        item.classList.add("opened"); 
                    } else {
                        item.classList.remove("opened"); 
                    }
                });

                 
                setTimeout(() => {
                    scroller.scrollTo(item, {
                      offset: -200, 
                      easing: [0, 0, 0, 0], 
                      duration: 100,
                    });
                  }, 400);
                
                setTimeout(() => {
                    scroller.update();
                  }, 800);
            })
        })
    }
}